import { type FC } from 'react'

import {
  LOGIN_SOURCE_PAGE,
  LoginRegistrationUserLoginContent,
  useGetRedirectToTargetPage,
} from '../../login-registration'

export const LoginRegistrationLoginSection: FC = () => {
  const redirectToTargetPage = useGetRedirectToTargetPage(LOGIN_SOURCE_PAGE)

  return (
    <div className="z-10 basis-1/2 tablet:mb-6 tablet:ml-6 tablet:mr-3">
      <div className="flex-1 bg-light-primary-low p-5 shadow-m tablet:rounded-2xl tablet:px-5">
        <LoginRegistrationUserLoginContent
          afterLoggedIn={redirectToTargetPage}
        />
      </div>
    </div>
  )
}
